import { useAuth } from "../context/AuthContext";
import style from "./Profile.module.css";

const ProfileModal = ({ isOpen, onClose, data }) => {
    const { logout } = useAuth();
    if (!isOpen || !data) return null;

    return (
        <div className={style.modalOverlay}>
            <div className={style.modalCard}>
                <button className={style.closeButton} onClick={onClose}>
                    &times;
                </button>

                <div className={style.profileHeader}>
                    <img
                        src={data.image_url}
                        alt="Profile"
                        className={style.profileImage}
                    />
                    <h2 className={style.profileName}>
                        {data.first_name} {data.last_name}
                    </h2>
                    <p className={style.statusBadge}>
                        {data.status}
                    </p>
                </div>

                <div className={style.infoGrid}>
                    <div className={style.infoItem}>
                        <label>Email</label>
                        <p>{data.email}</p>
                    </div>

                    <div className={style.infoItem}>
                        <label>Phone Number</label>
                        <p>{data.doctor_details?.phone_number}</p>
                    </div>

                    <div className={style.infoItem}>
                        <label>Experience</label>
                        <p>{data.doctor_details?.yrs_of_exp} years</p>
                    </div>
                </div>
                <button onClick={logout} className={style.logOutBtn}>Log Out</button>
            </div>
        </div>
    );
};

export default ProfileModal;
